import { useState } from 'react';

import { Button, Input, Switch } from '@components';
import { LOCAL_STORAGE_KEYS } from '@constants/storage';
import { META_WEBHOOK_BASE_URL } from '@features/lead-management/constants/leadSettings';
import { getLocalStorageItem } from '@utils/storage';

import MetaAccessTokenBanner from './MetaAccessTokenBanner';

const readOnlyInputStyle =
  'h-12.5 w-full rounded-lg border border-grey30 bg-grey10 px-4 py-2.5 pr-10 text-base font-normal leading-none tracking-normal text-grey80';

const editableInputStyle =
  'h-12.5 w-full rounded-lg border border-grey30 px-4 py-2.5 text-base font-normal leading-none tracking-normal placeholder:text-cofeeNeutral6 focus:border-cofeePrimary6 focus:outline-none';

const MetaInstagramIntegration = () => {
  const organizationId = getLocalStorageItem(
    LOCAL_STORAGE_KEYS.ORGANIZATION_ID
  );

  const [isActive, setIsActive] = useState(true);
  const [accessToken, setAccessToken] = useState('');
  const [appSecret, setAppSecret] = useState('');

  const webhookUrl = `${META_WEBHOOK_BASE_URL}/${organizationId}`;
  const verifyToken = organizationId ?? '';

  return (
    <div>
      <div className="space-y-6 p-6">
        <div className="space-y-1">
          <div className="flex items-center gap-3">
            <Switch
              value={isActive}
              handleClick={setIsActive}
              testId="instagram-lead-sync"
            />
            <span className="text-base font-semibold text-greyText1">
              Enable lead syncing from instagram
            </span>
          </div>
          <p className="text-sm text-grey80">
            Pause or resume automatic ingestion of Meta leads from instagram.
          </p>
        </div>

        <div className="space-y-2">
          <label className="text-sm font-semibold tracking-[-0.2px] text-greyText1">
            Access token<span className="text-error"> *</span>
          </label>
          <Input
            type="text"
            value={accessToken}
            handleInputChange={setAccessToken}
            placeholder="Enter access token"
            className="w-full max-w-[396px]"
            inputStyle={editableInputStyle}
          />
        </div>

        <div className="space-y-2">
          <label className="text-sm font-semibold tracking-[-0.2px] text-greyText1">
            App secret<span className="text-error"> *</span>
          </label>
          <Input
            type="password"
            value={appSecret}
            handleInputChange={setAppSecret}
            placeholder="Enter app secret"
            className="w-full max-w-[396px]"
            inputStyle={editableInputStyle}
          />
          <MetaAccessTokenBanner
            wrapperClassName="max-w-[396px]"
            bannerClassName="!px-0.5 hover:opacity-80"
          />
        </div>

        <div className="space-y-3 border-t border-grey20 pt-6">
          <div className="space-y-1">
            <p className="text-base font-semibold text-greyText1">
              Configure Webhook in your meta account
            </p>
            <p className="text-sm text-grey80">
              Copy the below webhook url and verify token and paste it into meta
              account
            </p>
          </div>

          <div className="space-y-2">
            <label className="text-sm font-semibold text-greyText1">
              Webhook URL
            </label>
            <Input
              type="text"
              value={webhookUrl}
              readOnly
              showTooltip
              textToCopy={webhookUrl}
              className="w-full max-w-[396px]"
              inputStyle={readOnlyInputStyle}
            />
          </div>

          <div className="space-y-2">
            <label className="text-sm font-semibold text-greyText1">
              Verify token
            </label>
            <Input
              type="text"
              value={verifyToken}
              readOnly
              showTooltip
              textToCopy={verifyToken}
              className="w-full max-w-[396px]"
              inputStyle={readOnlyInputStyle}
            />
          </div>
        </div>
      </div>

      <div className="flex min-h-17 items-center justify-end gap-3 px-6 pb-6">
        <Button variant="primary" className="px-4 py-2 text-white">
          Verify and save
        </Button>
      </div>
    </div>
  );
};

export default MetaInstagramIntegration;
